import { useQuery } from '@apollo/client';
import { GET_STORE_BY_ID } from '../../graphql/stores';
import { sessionSubject } from '../../state/sessionObservable';
import { useEffect, useState } from 'react';
import { distinctUntilChanged } from 'rxjs';
import { localComms } from '../../utils/localComms';

export const useStore = () => {
  const [storeId, setStoreId] = useState<string | null>(null);

  // Subscribe to session changes and extract storeId
  useEffect(() => {
    const subscription = sessionSubject
      .pipe(
        distinctUntilChanged(
          (prev, curr) => prev.currentStore?.id === curr.currentStore?.id, // only emit when store ID changes
        ),
      )
      .subscribe(session => {
        setStoreId(session.currentStore?.id ?? null);
      });

    return () => subscription.unsubscribe();
  }, []);

  // Apollo query automatically re-runs when `storeId` changes
  const { data, loading, error } = useQuery(GET_STORE_BY_ID, {
    variables: { id: storeId },
    skip: !storeId, // don't query until storeId is set
    fetchPolicy: 'cache-and-network',
    onCompleted(data) {
      localComms.onLocalCommsToggleChange(
        data?.store?.enableLocalComms ?? false,
      );
    },
  });

  return {
    store: data?.store,
    loading,
    error,
  };
};
